module.exports = __webpack_public_path__ + "static/media/walga-twl-logo.52dbadbf.png";